function LoadingProductCard({ isFromGrid }) {
  return (
    <div
      className={`${isFromGrid ? 'flex gap-2.5' : ''} border-border w-full animate-pulse overflow-hidden rounded-lg border`}
    >
      {/* Image Skeleton */}
      <div
        className={`relative ${isFromGrid && 'w-44'} cursor-pointer rounded-lg bg-gray-200`}
      >
        <div className='h-48 w-full rounded-lg bg-gray-300 max-md:h-32' />
      </div>

      {/* Text & Price Skeleton */}
      <div className='w-full p-3'>
        {/* Brand Placeholder */}
        <div className='mb-2 h-3 w-16 rounded bg-gray-300' />

        {/* Product Name Placeholder */}
        <div className='mb-2 h-6 w-3/4 rounded bg-gray-300' />

        {/* Model Placeholder */}
        <div className='mb-2 h-4 w-1/2 rounded bg-gray-300' />

        {/* Price & Discount Row */}
        <div
          className={`mt-2 flex items-center justify-between ${isFromGrid ? 'flex-col items-start' : ''}`}
        >
          <div className='mb-2 h-5 w-16 rounded bg-gray-300' />
          <div className='h-4 w-12 rounded bg-gray-300' />
        </div>

        {/* Discount Banner Placeholder */}
        <div className='mt-2 flex h-6 items-center justify-between rounded-lg bg-gray-300 px-2 py-1' />
      </div>
    </div>
  );
}

export default LoadingProductCard;
